import { matchPath } from 'react-router-dom';

const PRODUCT = 'CensusZen';

// Pattern → label. Patterns use react-router syntax and are tried in order,
// so put literal paths before parameterised ones that could also match.
// Labels carry no patient data: the case page is always "Case".
export const ROUTE_TITLES = [
    ['/', null],
    ['/login', 'Sign in'],
    ['/register', 'Create account'],
    ['/request-access', 'Request access'],
    ['/forgot-password', 'Reset password'],
    ['/privacy', 'Privacy policy'],
    ['/terms', 'Terms of service'],
    ['/faq', 'FAQ'],
    ['/pricing', 'Pricing'],
    ['/accept-tos', 'Terms of service'],
    ['/verify-email', 'Verify your email'],
    ['/mfa-setup', 'Two-factor authentication'],
    ['/cases', 'Cases'],
    ['/case/new', 'New case'],
    ['/case/:caseId', 'Case'],
    ['/admin', 'Admin'],
    ['/admin/workflows', 'Workflows'],
    ['/admin/workflows/:configId', 'Workflow'],
    ['/facility/:facilityId/dashboard', 'Facility overview'],
    ['/facility/:facilityId/team', 'Team'],
    ['/billing', 'Billing'],
    ['/help', 'Help'],
    ['/profile', 'Profile'],
];

/**
 * Document title for a pathname.
 *
 * Args:
 *     pathname: The location pathname, without query string or hash.
 *
 * Returns:
 *     string: "<Label> · CensusZen", or "CensusZen" for the root and for
 *         any path the table does not know.
 */
export function titleForPath(pathname) {
    for (const [pattern, label] of ROUTE_TITLES) {
        if (matchPath({ path: pattern, end: true }, pathname)) {
            return label ? `${label} · ${PRODUCT}` : PRODUCT;
        }
    }
    return PRODUCT;
}
